import React from "react";
import submitSvg from "../../static/submit.svg";

export const FreeFormAnswers = ({
    freeFormValue,
    confirmBtnHandler,
    changeFreeFormAnswer,
    isConfirmPossible,
    isBackBtnActive,
    backBtnHandler,
}) => {
    return (
        <div className="freeform-new">
            <textarea
                value={freeFormValue}
                onChange={changeFreeFormAnswer}
                placeholder="Введи свой ответ"
                autoFocus
            />
            <button
                className={`freeform-new__confirm${isConfirmPossible ? " freeform-new__confirm--active" : ""}`}
                onClick={isConfirmPossible ? confirmBtnHandler : undefined}
                disabled={!isConfirmPossible}
            >
                <img src={submitSvg} width="56" height="56" alt="" />
            </button>
        </div>
    );
};
